import { css } from 'aphrodite';
import { Slot } from 'radix-ui';
import React from 'react';
import { Separator } from '../../components/Separator';
import { s } from './styles';

interface ButtonGroupProps extends AphroditeStyled<React.ComponentProps<'div'>> {
	orientation?: 'horizontal' | 'vertical';
}

const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
	({ orientation = 'horizontal', styles = [], ...props }, ref) => {
		return (
			<div
				ref={ref}
				role='group'
				data-slot='button-group'
				data-orientation={orientation}
				className={css(s.base, orientation === 'horizontal' ? s.horizontal : s.vertical, ...styles)}
				{...props}
			/>
		);
	}
);
ButtonGroup.displayName = 'ButtonGroup';

interface ButtonGroupTextProps extends AphroditeStyled<React.ComponentProps<'div'>> {
	asChild?: boolean;
}

const ButtonGroupText = React.forwardRef<HTMLDivElement, ButtonGroupTextProps>(
	({ asChild = false, styles = [], ...props }, ref) => {
		const Comp = asChild ? Slot.Root : 'div';

		return <Comp ref={ref} className={css(s.text, ...styles)} {...props} />;
	}
);
ButtonGroupText.displayName = 'ButtonGroupText';

interface ButtonGroupSeparatorProps extends React.ComponentProps<typeof Separator> {
	orientation?: 'horizontal' | 'vertical';
}

const ButtonGroupSeparator = React.forwardRef<React.ElementRef<typeof Separator>, ButtonGroupSeparatorProps>(
	({ orientation = 'vertical', styles = [], ...props }, ref) => {
		return (
			<Separator
				ref={ref}
				data-slot='button-group-separator'
				orientation={orientation}
				styles={[s.separator, ...styles]}
				{...props}
			/>
		);
	}
);
ButtonGroupSeparator.displayName = 'ButtonGroupSeparator';

export { ButtonGroup, ButtonGroupSeparator, ButtonGroupText };
